import {IsOptional, ValidateIf} from '@pristine-ts/class-validator';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import {
  IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions,
} from '../../../income-tax/personal/personal/income-tax-personal-spouse-federal-in-income-tax-personal.options';

@translationBaseKey('income-tax-personal-spouse-federal-in-rrsp-options')
export class IncomeTaxPersonalSpouseFederalInRrspOptions implements IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions {

  @clonePropertyMetadata<IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions>(IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions, 'maximumAllowedDeductibleContributionsRRSP')
  // Override to always validate
  @ValidateIf(o => true)
    // todo set a warning if paid contribution > maximum allowed.
  maximumAllowedDeductibleContributionsRRSP: number = 0;

  @clonePropertyMetadata<IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions>(IncomeTaxPersonalSpouseFederalInIncomeTaxPersonalOptions, 'paidContributionRRSP')
  @IsOptional()
  // todo validate only if is spouse
  paidContributionRRSP: number;
}
